export var PLANS = ['BASIC', 'PREMIUM'];
export var COVERED_AREAS = ['AREA_ONE', 'AREA_TWO'];
export var AGE_GROUPS = [
    'Child',
    '18-25',
    '26-29',
    '30-34',
    '35-39',
    '40-44',
    '45-49',
    '50-54',
    '55-59',
    '60-64',
    '65-69',
    '70-74',
    '75-79',
    '80+',
];
export var DEDUCTIBLES = [
    '0',
    '150',
    '375',
    '750',
    '1500',
    '3750',
    '7500',
    '15000',
];
export var OCCUPATIONS = [
    'SELF_EMPLOYED',
    'EMPLOYED',
    'HAVE_A_JOB_OFFER',
    'UNEMPLOYED',
    'STUDENT',
    'PROFESSIONAL_ATHLETE',
    'OTHER',
];
export var taxRatesLookup = {
    de: 0,
    es: 0.0015,
    fr: 0.07,
    nl: 0,
    it: 0.025,
    be: 0.0925,
    se: 0,
    mt: 0,
    at: 0.01,
    fi: 0,
    cy: 0,
    gr: 0.15,
    ee: 0,
    pt: 0.05,
    lt: 0,
    hr: 0,
    lv: 0,
    mc: 0,
    eu: 0,
};
